module.exports = __webpack_public_path__ + "static/media/direct-to-mail-logo.23ae7019.png";